import { useEffect, useRef } from "react";
import { useUiLanguage } from "../i18n";

interface ModalProps {
    readonly title: string;
    readonly subtitle?: string;
    readonly children: React.ReactNode;
    readonly onClose: () => void;
    readonly footer?: React.ReactNode;
    readonly className?: string;
}

export function Modal({ title, subtitle, children, onClose, footer, className }: ModalProps): React.JSX.Element {
    const { t } = useUiLanguage();
    const dialogRef = useRef<HTMLDialogElement>(null);

    useEffect(() => {
        const dialog = dialogRef.current;
        if (dialog !== null && !dialog.open) {
            dialog.showModal();
        }
        return () => dialog?.close();
    }, []);

    return (
        <dialog
            ref={dialogRef}
            className={`dialog${className === undefined ? "" : ` ${className}`}`}
            onCancel={(event) => {
                event.preventDefault();
                onClose();
            }}
        >
            <div className="dialog-card">
                <header className="dialog-header">
                    <div>
                        <h2>{title}</h2>
                        {subtitle === undefined ? null : <p>{subtitle}</p>}
                    </div>
                    <button className="icon-button" type="button" onClick={onClose} aria-label={t("closeDialog")}>
                        ×
                    </button>
                </header>
                <div className="dialog-body">{children}</div>
                {footer === undefined ? null : <footer className="dialog-footer">{footer}</footer>}
            </div>
        </dialog>
    );
}
